//#region [IMPORT]
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import './index.css';

// === API ===
import { subscribeWorkflowMonitor, unsubscribeWorkflowMonitor } from 'api/prokey/prokey.websocket';

// === COMPONENTS ===
import { ModulePanel } from './ModulePanel';
import { BatchPanel } from './BatchPanel';
import { AppContext } from 'pages/App/components/AppContext/AppContext';

//#endregion
//-----------------------------------------------------------------
export function WorkflowMonitor() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user_details } = useContext( AppContext );

  const theme = useTheme();
  const navigate = useNavigate();

  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'manager');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';
  
  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height    : `calc(100% - 5rem)`,
      'z-index' : '0',
      padding   : '1rem',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
      overflow: 'auto'
    },
    // MODULES
    modules_panel: {
      width: '100%',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
    modules_title: {
      padding : '1rem',
      width   : '100%',
    },
    modules_detail: {
      height    : '100%',
      padding: 0,
    },
    // BATCHES
    batches_panel: {
      width: '100%',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
    batches_detail: {
      height: '60%',
      padding: 0,
    }
  }

  // === ATTRIBUTES

  const CONTAINER = {
    sx : _styles.container,
  }

  const MODULES_PANEL = {
    sx              : _styles.modules_panel,
    key             : 'modules-panel',
    variant         : 'primary',
    defaultExpanded : true,
  }
  const MODULES_DETAIL = {
    sx  : _styles.modules_detail,
    key : 'modules-detail',
  }
  
  const BATCHES_PANEL = {
    sx              : _styles.batches_panel,
    key             : 'batches-panel',
    variant         : 'primary',
    defaultExpanded : true,
  }
  const BATCHES_DETAIL = {
    sx  : _styles.batches_detail,
    key : 'batches-detail',
  }

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    window.onbeforeunload = function() {
      unsubscribeWorkflowMonitor();
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    subscribeWorkflowMonitor();

    return () => {
      unsubscribeWorkflowMonitor();
    };
  }, []);

  useEffect(() => {
    if(!hasPermission && user_details.roles.length > 0) {
      navigate( '/' + page )  
    };
  }, [hasPermission, page, navigate, user_details]);  

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <Accordion { ...MODULES_PANEL } >
          <AccordionSummary key={'accordionsummary1'} expandIcon={<ExpandMoreIcon />}>
            <Typography variant='h5' color='primary'>Modules & Processes</Typography>
          </AccordionSummary>
          <AccordionDetails  { ...MODULES_DETAIL } >
            <ModulePanel key={'modulepanel1'} />
          </AccordionDetails>
        </Accordion>
        <Accordion  { ...BATCHES_PANEL } >
          <AccordionSummary key={'accordionsummary2'} expandIcon={<ExpandMoreIcon />}>
            <Typography variant='h5' color='primary'>Batches</Typography>
          </AccordionSummary>
          <AccordionDetails  { ...BATCHES_DETAIL } >
            <BatchPanel key={'batchpanel1'} />
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  };

  //#endregion

  return display();
}
